import { render, staticRenderFns } from "./EventsPopUp.vue?vue&type=template&id=3726837b&scoped=true&"
import script from "./EventsPopUp.vue?vue&type=script&lang=js&"
export * from "./EventsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./EventsPopUp.vue?vue&type=style&index=0&id=3726837b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3726837b",
  null
  
)

export default component.exports